class Drag {
  /**
   * @param {Number} threshold define in percents how much drag is needed to trigger transition,
   *   used in `underThreshold`
   */
  constructor(threshold) {
    this.threshold = threshold;
    this.#setDefaults();
  }

  get active() {
    return this.startX !== 0 && !this.discarded;
  }

  get distance() {
    // endX might be blank if we process just a single click (not actual drag),
    // so for that case we fall back to startX
    return (this.endX || this.startX) - this.startX;
  }

  get absoluteDistance() {
    return Math.abs(this.distance);
  }

  /**
   * @param {Number} width current width of a window
   * @return {boolean} whether or not transition should be triggered
   */
  underThreshold(width) {
    return (100 / width) * this.absoluteDistance < this.threshold;
  }

  /**
   * Track user interaction start.
   *
   * @param {TouchEvent | MouseEvent} e touchstart or mousedown event
   */
  started(e) {
    if ('touches' in e) {
      this.startX = e.touches[0].pageX;
      this.startY = e.touches[0].pageY;
    } else {
      this.startX = e.pageX;
    }
  }

  /**
   * Tracks movement (touch, mouse) of a user. The returned boolean value indicates
   * if interaction was tracked or skipped. The interaction might be skipped on
   * touch devices, when Y position delta was bigger than X position delta,
   * indicating user wanted to just scroll the site vertically.
   *
   * @param {TouchEvent | MouseEvent} e touchmove or mousemove event
   * @return {boolean} whether or not movement was tracked or skipped
   */
  moved(e) {
    if (this.discarded) {
      return !this.discarded;
    }

    if ('touches' in e) {
      this.discarded =
        Math.abs(this.startY - e.touches[0].pageY) > Math.abs(this.startX - e.touches[0].pageX);

      this.endX = e.touches[0].pageX;
    } else {
      this.endX = e.pageX;
    }

    return !this.discarded;
  }

  reset() {
    this.#setDefaults();
  }

  #setDefaults() {
    this.startX = 0;
    this.endX = 0;

    this.startY = 0;

    this.discarded = false;
  }
}

export default Drag;
